import { EnvironmentId } from '@/react/portainer/environments/types';

export const queryKeys = {
  customResourceDefinitions: (environmentId: EnvironmentId) =>
    [
      'environments',
      environmentId,
      'kubernetes',
      'customResourceDefinitions',
    ] as const,
  customResourceDefinition: (
    environmentId: EnvironmentId,
    name: string,
    yaml?: boolean
  ) =>
    [queryKeys.customResourceDefinitions(environmentId), name, yaml] as const,
  customResources: (environmentId: EnvironmentId, definition: string) =>
    [
      'environments',
      environmentId,
      'kubernetes',
      'customResources',
      definition,
    ] as const,
  customResource: (
    environmentId: EnvironmentId,
    definition: string,
    name: string,
    namespace?: string,
    yaml?: boolean
  ) =>
    [
      queryKeys.customResources(environmentId, definition),
      namespace,
      name,
      yaml,
    ] as const,
};
